import {CustomWindow, ReduxDevtoolsExtensionOptions, sentryReduxEnhancer} from '@fl/cmsch-fe-library';
import {AnyAction, applyMiddleware, compose, legacy_createStore} from 'redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import createSagaMiddleware from 'redux-saga';
import {opt, ReduxDevtoolsCompatibilityHelper} from 'ts-opt';

import {Config} from 'app/config';

import {defaultState} from './default-state';
import {navigationMiddleware} from './middleware/navigation-middleware';
import {windowMiddleware} from './middleware/window-middleware';
import {createReducer} from './reducer';
import saga from './saga';
import {State} from './state';

const reduxDevtoolsOptions: ReduxDevtoolsExtensionOptions = {
    serialize: {
        replacer: ReduxDevtoolsCompatibilityHelper.replacer,
        reviver: ReduxDevtoolsCompatibilityHelper.reviver,
    },
    actionsBlacklist: ['@@redux-form/REGISTER_FIELD', '@@redux-form/UNREGISTER_FIELD'],
};

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = opt((window as CustomWindow).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
    .map(f => f(reduxDevtoolsOptions))
    .orElse(compose);

const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware, navigationMiddleware, windowMiddleware];

if (Config.isDevelopment && !Config.disableImmutabilityCheck) {
    middlewares.push(reduxImmutableStateInvariant());
}

const reducer = createReducer();
const enhancer = composeEnhancers(compose(applyMiddleware(...middlewares), sentryReduxEnhancer));
/**
 * Shared Redux store instance configured with saga, navigation, and error tracking middleware.
 *
 * @returns Configured Redux store instance.
 */
const store = legacy_createStore<State, AnyAction, unknown, unknown>(
    reducer,
    defaultState,
    enhancer,
);

sagaMiddleware.run(saga);

export {store};
